import { GeographyTypeEnum } from '../enums';

export const autocompleteItemsMock = [
    {
        path: '/noclegi/zakopane/',
        name: 'Zakopane',
        caption: 'Góry, Małopolskie, pow. tatrzański, Polska',
        details: {
            accommodationsCount: 1387,
            popularity: 215186,
            voivodeshipId: '8',
            regionId: '1',
            location: {
                lon: 19.956666666667,
                lat: 49.298333333333,
            },
            radius: 19495,
            countryId: '1',
            cityId: '65',
        },
        id: 'city/65',
        type: GeographyTypeEnum.city,
    },
    {
        path: '/noclegi/zachodniopomorskie/',
        name: 'Województwo Zachodniopomorskie',
        caption: 'Polska',
        details: {
            accommodationsCount: 5578,
            popularity: 10742,
            voivodeshipId: '17',
            location: {
                lon: 15.682405154608274,
                lat: 53.67198941605429,
            },
            radius: 299750,
            countryId: '1',
        },
        id: 'voivodeship/17',
        type: GeographyTypeEnum.voivodeship,
    },
    {
        path: '/noclegi/zawoja/',
        name: 'Zawoja',
        caption: 'Góry, Małopolskie, pow. suski, Polska',
        details: {
            accommodationsCount: 128,
            popularity: 10713,
            voivodeshipId: '8',
            regionId: '1',
            location: {
                lon: 19.555333333333,
                lat: 49.663666666667,
            },
            radius: 19538,
            countryId: '1',
            cityId: '307',
        },
        id: 'city/307',
        type: GeographyTypeEnum.city,
    },
    {
        path: '/noclegi/zator/',
        name: 'Zator',
        caption: 'Śląsk, Małopolskie, pow. oświęcimski, Polska',
        details: {
            accommodationsCount: 106,
            popularity: 8480,
            voivodeshipId: '8',
            regionId: '21',
            location: {
                lon: 19.438056,
                lat: 49.996389,
            },
            radius: 19876,
            countryId: '1',
            cityId: '15220',
        },
        id: 'city/15220',
        type: GeographyTypeEnum.city,
    },
    {
        path: '/rezerwuj/681196-hostel-70s-and-queen-apartments-krakow/',
        name: 'Hostel 70s and Queen Apartments Kraków',
        caption: 'Kraków, apartamenty, PL',
        id: 'accommodation/681196',
        type: GeographyTypeEnum.accommodation,
        details: {
            popularity: 1,
        },
    },
];
